<template>
  <section>
    <div v-if="loading" class="content content-centered">
      <pulse-loader></pulse-loader>
    </div>
    <div v-show="!loading" class="content">
      <div class="box">
        <div class="box-body">
          <div class="row">
            <div
              class="flash-message col-md-4 col-md-offset-4 text-center"
              v-if="flash"
            >
              <div class="alert" :class="'alert-' + flashType">
                {{ flashMessage }}
              </div>
            </div>
          </div>
          <div id="details" class="row">
            <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
              <div class="col-sm-12">
                <div class="col-sm-6">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.brand)"
                  >
                    <label>Brand</label>
                    <input
                      type="text"
                      minlength="2"
                      name="brand"
                      class="form-control"
                      required
                      v-model.lazy="device.brand"
                      placeholder="Brand Name"
                    />
                    <field-messages
                      name="brand"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required">Brand name is a required field</div>
                      <div slot="pattern">Brand name is invalid</div>
                      <div slot="minlength">
                        Minimum length of brand is 2 character
                      </div>
                    </field-messages>
                  </validate>
                </div>
                <div class="col-sm-6">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.deviceModel)"
                  >
                    <label>Model</label>
                    <input
                      type="text"
                      name="deviceModel"
                      class="form-control"
                      required
                      v-model.lazy="device.deviceModel"
                      placeholder="Model"
                    />
                    <field-messages
                      minlength="3"
                      name="deviceModel"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required">Model is a required field</div>
                      <div slot="pattern">Model is invalid</div>
                      <div slot="minlength">
                        Minimum length of model is 3 character
                      </div>
                    </field-messages>
                  </validate>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="col-sm-6">
                  <validate
                    auto-label
                    class="form-group"
                    :class="fieldClassName(formstate.imei)"
                  >
                    <label>IMEI</label>
                    <input
                      type="number"
                      name="imei"
                      minlength="14"
                      class="form-control"
                      required
                      v-model.lazy="device.imei"
                      placeholder="IMEI"
                    />
                    <field-messages
                      name="imei"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <!-- <div slot="required">IMEI is a required field</div> -->
                      <div slot="pattern">IMEI is invalid</div>
                      <div slot="minlength">Minimum 14 number required</div>
                    </field-messages>
                  </validate>
                </div>
                <div class="col-sm-6">
                  <validate
                    auto-label
                    class="form-group"
                    :class="fieldClassName(formstate.connectionId)"
                  >
                    <label>Connection ID</label>
                    <input
                      type="number"
                      name="connectionId"
                      minlength="14"
                      class="form-control"
                      required
                      v-model.lazy="device.connectionId"
                      placeholder="Connection ID"
                    />
                    <field-messages
                      name="connectionId"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <!-- <div slot="required">Connection ID is a required field</div> -->
                      <div slot="pattern">Connection ID is invalid</div>
                      <div slot="minlength">Minimum 14 number required</div>
                    </field-messages>
                  </validate>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="col-sm-6">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.deviceId)"
                  >
                    <label>Device ID</label>
                    <input
                      type="text"
                      minlength="3"
                      name="deviceId"
                      class="form-control required-field"
                      required
                      v-model.lazy="device.deviceId"
                      placeholder="Device ID"
                    />
                    <field-messages
                      name="deviceId"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required">Device ID is a required field</div>
                      <div slot="pattern">Device ID is invalid</div>
                      <div slot="minlength">
                        Minimum length of Device is 3 character
                      </div>
                    </field-messages>
                  </validate>
                </div>
                <div class="col-sm-6">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.dateAdded)"
                  >
                    <label for="dateAdded">Registration Date</label>

                    <date-picker
                      required
                      id="dateAdded"
                      v-model="device.dateAdded"
                      lang="en"
                      name="dateAdded"
                      input-class="form-control"
                      width="100%"
                      use-utc="true"
                      format="DD-MM-YYYY"
                    ></date-picker>
                    <field-messages
                      name="dateAdded"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required">
                        Commissioning date is a required field
                      </div>
                      <div slot="pattern">Commissioning date is invalid</div>
                    </field-messages>
                  </validate>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="col-sm-6">
                  <validate
                    class="form-group"
                    :class="fieldClassName(formstate.deviceDescription)"
                  >
                    <label>Description</label>
                    <input
                      type="text"
                      name="deviceDescription"
                      class="form-control"
                      v-model="device.deviceDescription"
                      placeholder="Description"
                    />
                  </validate>
                </div>
                <div class="col-sm-6">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.status)"
                  >
                    <label>Status</label>
                    <select
                      required
                      v-model="device.status"
                      name="status"
                      class="form-control"
                    >
                      <option value="" disabled>Select Status</option>
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>
                    <field-messages
                      name="status"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required">Status is a required field</div>
                      <div slot="pattern">Status date is invalid</div>
                    </field-messages>
                  </validate>
                </div>
              </div>
            </vue-form>
            <div class="col-sm-12 text-right">
              <router-link :to="{ name: 'Devices' }">
                <button class="mr-5 btn btn-default" type="button">
                  Cancel
                </button>
              </router-link>
              <button
                class="mr-2 btn bt"
                type="submit"
                @click="createDevice"
                :disabled="!(formstate.$dirty && formstate.$valid)"
              >
                Add Device
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { formService, eventBus, deviceService } from '../../../services';
import { EVENTS } from '../../../config';

export default {
  name: 'DeviceCreate',
  data() {
    return {
      loading: false,
      flash: false,
      flashType: null,
      flashMessage: '',
      EVENTS: EVENTS,
      formstate: {},
      dateAdded: '',
      device: {
        status: 'active',
      },
    };
  },
  methods: {
    fieldClassName: formService.fieldClassName,

    createDevice() {
      this.loading = true;
      console.log('hii', this.device);
      return deviceService
        .addDevice(this.device)
        .then(response => {
          this.loading = false;
          this.flash = false;
          this.$snotify.success('Device added!', 'Success!');
          this.$router.push('/device');
        })
        .catch(error => {
          this.loading = false;
          this.$snotify.error('Device Add failed!Try Again', 'Error!');
          if (error.data.message.includes('must be one of')) {
            this.flash = true;
            this.flashType = 'error';
            this.flashMessage = 'New device add is failed.Please try again!';
          }
        });
    },
    fieldClassName: function(field) {
      if (!field) {
        return '';
      }
      if ((field.$touched || field.$submitted) && field.$valid) {
        return 'has-success';
      }
      if ((field.$touched || field.$submitted) && field.$invalid) {
        return 'has-danger';
      }
    },
  },
};
</script>
<style scoped>
.required-field label::after {
  content: '*';
  color: red;
  margin-left: 0.25rem;
}

.form-control-feedback {
  font-weight: 100;
  color: red;
  position: initial;
  text-align: left;
  height: auto;
  width: auto;
}
.has-danger {
  color: red;
}
.box-body {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
.bt {
  background-image: linear-gradient(
    to right,
    rgba(38, 153, 251),
    rgba(146, 205, 255)
  );
  color: white;
}
</style>



// WEBPACK FOOTER //
// DeviceCreate.vue?93446b00